import { useEffect } from "react";
import { eventBus, Events } from "utils/eventBus";

interface UseEventBusProps<FnHandler = (method: string) => void> {
  keyEvent: keyof Events;
  handler: FnHandler;
}

export function useEventBus({ keyEvent, handler }: UseEventBusProps) {
  useEffect(() => {
    eventBus.on(keyEvent, handler);
    return () => {
      eventBus.off(keyEvent, handler);
    };
  }, [handler, keyEvent]);
}
